'use strict';

import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { geSurveyAbTestVariants } from 'app/utils/abiskoUtils';
import { useQuery } from 'urql';
import SurveyQuery from './Survey.graphql';
import { useLocalStorage } from 'app/hooks/useLocalStorage';
import { useRouter } from 'next/router';
import { pathNoQueryHash } from 'app/utils/urlUtil';
import Survey from 'app/ui-components/Survey/Survey';
import ThankYou from 'app/ui-components/Survey/ThankYou';

export const SurveyData = ({ abTestVariants }) => {
    const router = useRouter();
    const url = pathNoQueryHash(router.asPath);
    const [closed, setClosed] = useLocalStorage('closedSurveys', {});
    const [participated, setParticipated] = useLocalStorage('participatedInSurveys', {});

    const closedSurveys = Object.keys(closed);
    const participatedIn = Object.keys(participated);

    const handleOnCloseSurvey = (id) => {
        const newValue = { ...closed, [id]: true };
        setClosed(newValue);
    };

    let takeSurveyTimeout;
    const handleOnTakeSurvey = (id) => {
        const newValue = { ...participated, [id]: true };
        takeSurveyTimeout = window.setTimeout(() => {
            setParticipated(newValue);
        }, 2000);
    };

    useEffect(() => {
        return () => {
            window.clearTimeout(takeSurveyTimeout);
        };
    }, [takeSurveyTimeout]);

    const [result] = useQuery({
        query: SurveyQuery,
        variables: {
            abTestVariants,
        },
    });

    const { data, fetching, error } = result;

    if (fetching || error) {
        return null;
    }

    if (data) {
        if (data.surveys.length === 0) {
            return null;
        }

        const surveys = data.surveys.filter((survey) => !closedSurveys.includes(survey.id));

        const participatedInSurveys = data.surveys.filter((survey) => participatedIn.includes(survey.id));

        if (surveys.length === 0) {
            return null;
        }

        const survey = surveys[0];
        const thankYouSurvey = participatedInSurveys[0];

        if (participatedInSurveys.length > 0) {
            return <ThankYou survey={thankYouSurvey} onCloseSurvey={handleOnCloseSurvey}></ThankYou>;
        }

        const currentPage = survey.customAttributes.find((customAttribute) => customAttribute.key === 'page');

        const buttonText = survey.customAttributes.find(
            (customAttribute) => customAttribute.key === 'buttonText'
        );

        if (currentPage && currentPage.value !== url) {
            return null;
        }

        const isStart = url === '/';

        const buttonTextValue = buttonText?.value ? buttonText?.value : 'Jag vill tycka till';

        return (
            <Survey
                survey={survey}
                buttonText={buttonTextValue}
                onTakeSurvey={handleOnTakeSurvey}
                onCloseSurvey={handleOnCloseSurvey}
                isStart={isStart}
            />
        );
    }
};

const SurveyContainer = ({ abTestVariants }) => {
    const [isBrowser, setIsBrowser] = useState(false);

    useEffect(() => {
        setIsBrowser(true);
    }, []);

    if (!isBrowser || abTestVariants.length === 0) {
        return null;
    }

    return <SurveyData abTestVariants={abTestVariants} />;
};

const mapStateToProps = (state) => {
    return {
        abTestVariants: geSurveyAbTestVariants(state),
    };
};

export default connect(mapStateToProps)(SurveyContainer);
